/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  LeverageGetInterestRateOptions,
  LeverageGetInterestRateStatus200,
  LeverageGetInterestRateStatus400,
  LeverageGetInterestRateStatus401,
  LeverageGetInterestRateStatus404,
  LeverageGetInterestRateStatus500,
} from '../types/LeverageGetInterestRate'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { leverageGetInterestRate } from '../clients/leverageGetInterestRate'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const leverageGetInterestRateQueryKey = ({
  path,
  query,
}: Omit<LeverageGetInterestRateOptions, 'headers'>) =>
  [
    { url: '/v1/leverage/interest_rate/:asset_id', params: path },
    ...(query ? [query] : []),
  ] as const

type LeverageGetInterestRateQueryKey = ReturnType<typeof leverageGetInterestRateQueryKey>

export function leverageGetInterestRateQueryOptions(
  { path, query }: LeverageGetInterestRateOptions,
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = leverageGetInterestRateQueryKey({ path, query })
  return queryOptions<
    LeverageGetInterestRateStatus200,
    ResponseErrorConfig<
      | LeverageGetInterestRateStatus400
      | LeverageGetInterestRateStatus401
      | LeverageGetInterestRateStatus404
      | LeverageGetInterestRateStatus500
    >,
    LeverageGetInterestRateStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return leverageGetInterestRate({
        ...config,
        path,
        query,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @summary Get leverage borrowing and lending yields for a specific asset
 * {@link /v1/leverage/interest_rate/:asset_id}
 */
export function useLeverageGetInterestRate<
  TData = LeverageGetInterestRateStatus200,
  TQueryData = LeverageGetInterestRateStatus200,
  TQueryKey extends QueryKey = LeverageGetInterestRateQueryKey,
>(
  {
    path,
    query,
  }: {
    path: LeverageGetInterestRateOptions['path'] | (() => LeverageGetInterestRateOptions['path'])
    query?:
      | LeverageGetInterestRateOptions['query']
      | (() => LeverageGetInterestRateOptions['query'])
  },
  options: {
    query?: Partial<
      QueryObserverOptions<
        LeverageGetInterestRateStatus200,
        ResponseErrorConfig<
          | LeverageGetInterestRateStatus400
          | LeverageGetInterestRateStatus401
          | LeverageGetInterestRateStatus404
          | LeverageGetInterestRateStatus500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = {
    path: typeof path === 'function' ? path() : path,
    query: typeof query === 'function' ? query() : query,
  }
  const queryKey = resolvedOptions?.queryKey ?? leverageGetInterestRateQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...leverageGetInterestRateQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | LeverageGetInterestRateStatus400
      | LeverageGetInterestRateStatus401
      | LeverageGetInterestRateStatus404
      | LeverageGetInterestRateStatus500
    >
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
